module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-stone-path.4edf2fbb.png";